module.exports = __webpack_public_path__ + "326848fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LeftNavigation/images/autorizaciones.png
// module id = 1037
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13